import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'truncateDecimal',
})
export class TruncateDecimalPipe implements PipeTransform {
	transform(value: string | number): string {
		value = value.toString();
		const numberWithoutCommas = Number(value.replace(/,/g, ''));
		// due to floating-point precision limitations. (1.15 * 100, the result is 114.99999999999999)
		// that's why toFixed() is used
		// R&D
		// (10.99999 * 100).toFixed(2) = '1100.00' 
		// after applying toFixed it is rounding up the value
		// (10.9999 * 100).toFixed(2) = '1099.99' 
		// .9999 is working fine. 
		// if after decimal more than four 9 then rounding the value

		const wholeNumber = (numberWithoutCommas * 100).toFixed(2);
		// Truncate the number to two decimal places
		const truncatedNumber = Math.floor(Number(wholeNumber)) / 100;
		// Format the number with commas
		let formattedNumber = truncatedNumber.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		
		const indexOfDot = formattedNumber.indexOf('.');
		
		const numberOfDigitsAfterDot = indexOfDot === -1 ? 0 : formattedNumber.length - indexOfDot - 1;

		if (numberOfDigitsAfterDot === 0) {
			formattedNumber += ".00";
		} else if(numberOfDigitsAfterDot === 1) {
			formattedNumber += "0";
		}

		return formattedNumber;
	}
}
